import React from "react";
import {NavLink} from "react-router-dom"
import logo from "../../img/logo.png"
import './Logo.scss';

export const Logo = () => <div className="logo">
    <NavLink to="/" exact={true}>
        <img src={logo} alt=""/>
    </NavLink>
</div>